import React from 'react';
import { Icons } from '@ohif/ui-next';
import './Pagination.css';

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const leftText =
    totalItems > 0 && startItem > 0 && endItem >= startItem
      ? `Showing ${startItem} to ${endItem} of ${totalItems} results`
      : totalPages > 0
        ? `Page ${currentPage} of ${totalPages}`
        : '';

  return (
    <div className="pagination">
      <span className="pagination-info">{leftText}</span>
      <div className="pagination-controls">
        <button
          type="button"
          className="pagination-btn"
          onClick={handlePrevious}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          <Icons.ChevronLeft
            width="16"
            height="16"
          />
        </button>
        <span className="pagination-page-text">
          {totalPages > 0 ? `Page ${currentPage} of ${totalPages}` : ''}
        </span>
        <button
          type="button"
          className="pagination-btn"
          onClick={handleNext}
          disabled={currentPage >= totalPages}
          aria-label="Next page"
        >
          <Icons.ChevronRight
            width="16"
            height="16"
          />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
